module.exports = __webpack_public_path__ + "img/uw_logo.396f59bb.svg";